import { CourseService } from 'src/app/features/course/course.service'
import { Observable, of } from 'rxjs'
import {
  catchError,
  distinctUntilChanged,
  filter,
  map,
  switchMap,
  take,
  timeout
} from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'

import { Component, OnInit } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { Store } from '@ngrx/store'

import { Course } from '../course'
import { courseActions } from '../course.actions'
import { courseSelectors } from '../course.selectors'
import { Actions, ofType } from '@ngrx/effects'
import { NotificationService } from 'src/app/core/notification.service'
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'course-general-tab',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class CourseGeneralTabComponent implements OnInit {
  public course$: Observable<Course>
  public courseId$: Observable<number>
  public form: UntypedFormGroup
  constructor(
    private store: Store<AppState>,
    private actions$: Actions,
    private notificationService: NotificationService,
    private activeRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.courseId$ = this.activeRoute.params.pipe(
      map((params) =>
        params.hasOwnProperty('courseId') ? Number(params['courseId']) : null
      ),
      distinctUntilChanged()
    )

    this.course$ = this.courseId$.pipe(
      switchMap((courseId) => {
        if (courseId) {
          return this.store.select(courseSelectors.selectById, courseId)
        }
      })
    )
  }

  public onSubmit(form): void {
    // TODO fix this well by not getting relations of course in the form on submit
    delete form.tags
    delete form.translations
    // TODO emd fix this well

    this.courseId$.pipe(take(1)).subscribe((courseId) =>
      this.store.dispatch(
        courseActions.updateOneById({
          id: courseId,
          params: {
            ...form,
            id: parseInt(courseId.toString())
          }
        })
      )
    )

    this.actions$
      .pipe(
        ofType(courseActions.upsertMany),
        take(1),
        timeout(1000),
        catchError((error) => of(null))
      )
      .subscribe((action) =>
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      )
  }
}
